import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

import BodyModel from "modules/pain-profile/body-model";

class BodyModelWrapper extends React.Component {
  static propTypes = {
    input: PropTypes.object,
    question: PropTypes.object.isRequired
  };

  onChange = zoneId => {
    const { input } = this.props;
    const newValue = Array.isArray(input.value) ? [...input.value] : [];

    zoneId = zoneId.toString();

    if (!newValue.includes(zoneId)) {
      newValue.push(zoneId);
    } else {
      newValue.splice(newValue.indexOf(zoneId), 1);
    }

    return input.onChange(newValue);
  };

  render() {
    const {
      input: { value },
      question
    } = this.props;

    return (
      <BodyModel
        question={question}
        values={
          Array.isArray(value) ? value.map(item => parseInt(item, 10)) : []
        }
        onChange={this.onChange}
      />
    );
  }
}
const BodyModelField = props => (
  <Field component={BodyModelWrapper} {...props} />
);

export default BodyModelField;



// WEBPACK FOOTER //
// ./src/modules/forms/fields/body-model-field.js